import React from 'react'
import './ourHistory.css'
import Box from '@mui/material/Box';
import { history } from '../../../constant/constant'

const OurHistory = () => {
    return (
        <div className='ourExecutiveCommittee-containter'>
            <Box className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Our History</h2>
                </div>
                <div className='p-md-5 p-3 overallPadding'>
                    <div>
                        <h4 className='title-font text-center mb-2 mt-4' style={{ color: '#134b2b' }}>Milestones in Our History</h4>
                    </div>
                    <p className='content-font our-history-intro mb-5 mt-3'>
                        From its humble beginnings to becoming the largest professional association for teachers in India, ELTAI&#39;s
                        story is one of dedication, innovation, and collaboration. Join us as we delve into the significant milestones
                        that have shaped ELTAI over the years.
                    </p>
                    <div maxWidth="xl">
                        {history.map((data, i) => {
                            return (<div key={i}>
                                <h5 className={`text-center fw-bold history-title${data.id} title-font Futura-Bold-fontfamily mb-4`}>{data.title}</h5>
                                <div className='row'>
                                    <div className='row mb-3'>
                                        <div className='col-md-2 d-flex align-items-center justify-content-center'>
                                            <img src={data.img} alt={data.title} className='history-badge title-font' />
                                        </div>
                                        <div className='col-md-10 d-flex align-items-center justify-content-center'>
                                            <p className='history-content content-font'>
                                                {data.content}</p></div>
                                    </div>
                                </div>
                            </div>)
                        })
                        }
                    </div>
                    <div className="p-5">
                        <div className="ourhistory_card">
                            < p className='content-font ourhistory_content mb-0 ' > ELTAI’s journey over the past decades reflects its unwavering commitment to the advancement of Indian
                                English language teaching. As it strides confidently into the future, ELTAI remains a beacon of inspiration
                                for educators across India, fostering excellence and collaboration among English language teaching
                                fraternity.</p>
                        </div>
                    </div>
                </div>
            </Box>
        </div >
    )
}

export default OurHistory